import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import loginEn from '../../src/locales/Login/en.json';
import loginJp from '../../src/locales/Login/jp.json';
import dashboardEn from '../../src/locales/Dashboard/en.json';
import dashboardJp from '../../src/locales/Dashboard/jp.json';
import attendanceEn from '../../src/locales/Attendance/en.json';
import attendanceJp from '../../src/locales/Attendance/jp.json';
import layoutEn from '../../src/locales/layout/en.json';
import layoutJp from '../../src/locales/layout/jp.json';
import alcoholEn from '../../src/locales/Alcohol/en.json';
import alcoholJp from '../../src/locales/Alcohol/jp.json';
import driverEn from '../../src/locales/Driver/en.json';
import driverJp from '../../src/locales/Driver/jp.json';
import vehicleEn from '../../src/locales/Vehicle/en.json';
import vehicleJp from '../../src/locales/Vehicle/jp.json';
import deviceEn from '../../src/locales/Device/en.json';
import deviceJp from '../../src/locales/Device/jp.json';
import commonEn from '../../src/locales/common/en.json';
import commonJp from '../../src/locales/common/jp.json';
import clientEn from '../../src/locales/Client/en.json';
import clientJp from '../../src/locales/Client/jp.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      login: loginEn,
      attendance: attendanceEn,
      dashboard: dashboardEn,
      layout: layoutEn,
      alcohol: alcoholEn,
      driver: driverEn,
      vehicle: vehicleEn,
      device: deviceEn,
      common: commonEn,
      client: clientEn,
    },
    jp: {
      login: loginJp,
      attendance: attendanceJp,
      dashboard: dashboardJp,
      layout: layoutJp,
      alcohol: alcoholJp,
      driver: driverJp,
      vehicle: vehicleJp,
      device: deviceJp,
      common: commonJp,
      client: clientJp,
    },
  },
  lng: localStorage.getItem('language') || 'jp',
  fallbackLng: 'en',
  ns: [
    'login',
    'dashboard',
    'attendance',
    'layout',
    'alcohol',
    'driver',
    'vehicle',
    'device',
    'common',
    'client',
  ],
  defaultNS: 'login',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
